<template>
  <f7-page @page:init="onPageInit">
    <!-- Top Navbar -->
    <f7-navbar color-theme="orange">
      <f7-nav-left></f7-nav-left>
      <f7-nav-title>登录</f7-nav-title>
      <langButton></langButton>
    </f7-navbar>
    <f7-block class="text-align-center" v-if="isWeiXin()">
      <f7-preloader color="multi"></f7-preloader>
      <div>等待微信授权验证..</div>
    </f7-block>
    <f7-block class="text-align-center" v-else>
      暂不支持微信以外浏览器登录
    </f7-block>
  </f7-page>
</template>
<script>
import { getOAuthUrl } from "@/api/api";
import util from "util/date";
export default {
  props: {
    f7router: Object,
  },
  data() {
    return {};
  },
  methods: {
    isWeiXin() {
      return util.isWeiXin();
    },
    onPageInit() {
      if (util.isWeiXin() && !window.localStorage.OpenId) {
        getOAuthUrl().then((res) => {
          window.location.href = res.data.response;
        });
      }
    },
  },
};
</script>